import Post from '../post';
import classNames from 'classnames';

import styles from './post_package.module.scss';

function PostPackage({ posts, title, platform, setModalContents, toggleModal }) {

    return (
        <div className={classNames(styles.pinWrap, styles[`pinWrap--${platform}`])}>
            <h2>{title}</h2>
            {posts.map((post, i) =>
                <div className={styles['pin' + (i + 1)]} key={i}>
                    {/* <img src="https://www.fillmurray.com/300/300" /> */}
                    <Post
                        platform={platform}
                        position={i}
                        post={post}
                        setModalContents={setModalContents}
                        toggleModal={toggleModal}
                        subunit_tracking_data={{
                            subunit_type: 'package',
                            subunit_name: 'post_package',
                            position_in_unit: 0,
                            position_in_subunit: i
                        }} />
                </div>
            )}
        </div>
    );
}

export default PostPackage;
